import type React from 'react'

import { PageCount, Settings } from './components'
import css from './ProjectSettings.module.scss'

const ProjectSettings: React.FC = () => {
  return (
    <div className={css.container}>
      <Settings />

      <PageCount />
    </div>
  )
}

export default ProjectSettings
